export default __webpack_public_path__ + "static/media/close.cb4e6737.svg";